import script from "./reviews-section.vue?vue&type=script&setup=true&lang=js"
export * from "./reviews-section.vue?vue&type=script&setup=true&lang=js"

import "./reviews-section.vue?vue&type=style&index=0&id=b7748f5e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7748f5e"]])

export default __exports__